import { render } from "./BluePrint.vue?vue&type=template&id=08fb3ecc&scoped=true"
const script = {}

import "./BluePrint.vue?vue&type=style&index=0&id=08fb3ecc&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08fb3ecc"]])

export default __exports__